export default __webpack_public_path__ + "static/media/ac_mas.8dcc9131.bmp";